export default "__VITE_ASSET__BVhxlvxE__"